const BLACK = '#000';
const WHITE = '#fff';

function getContrastYIQ(hexcolor) {
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);

  return ((r * 299) + (g * 587) + (b * 114)) / 1000;
}

// exports
export function colorProducer(colors) {
  let i = 0;
  return () => colors[ (i += 1) % colors.length ];
}

export function splitBackgroundOf(colors) {
  return `linear-gradient(to right, ${_.map(colors, (color, ix) => {
    const interval = 100 / colors.length;
    const startPercentage = interval * ix;
    const endPercentage = interval * (ix + 1);

    return [
      `${color} ${startPercentage}%`,
      `${color} ${endPercentage}%`
    ].join(', ');
  }).join(', ')})`;
}

export function getContrastingTextColor(colorHex) {
  if (typeof colorHex !== 'string') {
    return null;
  }

  if (colorHex.length > 0 && colorHex[ 0 ] === '#') {
    colorHex = colorHex.substr(1);
  }

  if (colorHex.length !== 6) {
    return BLACK;
  }
  return getContrastYIQ(colorHex) >= 128 ? BLACK : WHITE;
}


// WEBPACK FOOTER //
// ./src/js/util/ColorUtil.js